<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell sort cell-large center" @click="setSorting('bonID')">
          Batch no
          <BaseIcon
            v-if="sortingOn == 'bonID'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-large center">Lot No</div>
        <div class="cell sort cell-large" @click="setSorting('ref')">
          REF
          <BaseIcon
            v-if="sortingOn == 'ref'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell sort cell-large center" @click="setSorting('rawmaterial')">
          Raw Mat
          <BaseIcon
            v-if="sortingOn == 'rawmaterial'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-big">Description</div>
        <LoadAmountList v-if="hasAmountDropdown" :totalItems="totalItems" @selectedAmount="selectedAmount" />
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{'active-line-padding': selectedOrder === order}"
        v-for="(order, index) in this.orders"
        :key="index"
        @click="selectRow(order)"
      >
        <div class="cell cell-large center">{{order.bonID}}</div>
        <div class="cell cell-large center" v-if="order.snummer != 0">{{order.snummer}}</div>
        <div class="cell cell-large center" v-else>-</div>
        <div class="cell cell-large">{{order.ref}}</div>
        <div class="cell cell-large center">{{order.rawMaterialID}}</div>
        <div class="cell cell-big">{{order.description}}</div>
        <div class="cell">
          <i class="icon grey fa fa-ellipsis-h"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import LoadAmountList from "@/components/base/LoadAmountList";

export default {
  components: {
    BaseIcon,
    LoadAmountList
  },
   
  props: {
    orders: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {},
  data() {
    return {
      selectedOrder: null,
      sortingOn: "bonID",
      isAscending: true
    };
  },
  methods: {
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    selectRow(order) {
      this.selectedOrder = order;
      this.$emit("selectedRow", order);
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}
</style>
